import { render, staticRenderFns } from "./ArticleRenderer.vue?vue&type=template&id=1f445716&scoped=true&"
import script from "./ArticleRenderer.vue?vue&type=script&lang=js&"
export * from "./ArticleRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRenderer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ArticleRenderer.vue?vue&type=style&index=1&id=1f445716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f445716",
  null
  
)

export default component.exports